<template>
  <div v-if="invoiceId">
    <router-view />
  </div>
</template>

<script>
export default {
	name: 'CheckoutComponent',
	props: ['invoice_id'],
	data () {
		return {}
	},

	computed: {
		invoiceId () {
			return this.$store.getters.checkoutInvoiceId
		}
	},
	async mounted () {
		// props [ invoice_id ] comes from DynamicComponent.vue which comes from checkout.php
		if (this.invoice_id !== undefined) {
			this.$store.dispatch('setCheckoutInvoiceId', this.invoice_id)
			// We don't have the invoice, get it
			await this.$store.dispatch('getCustomerInvoice', { invoiceId: this.invoice_id })
			const invoices = this.$store.getters.invoices
			const invoice = invoices[`INVOICEID_${this.invoice_id}`]
			// Check if this is a marketplace invoice
			if (invoice && invoice.marketplace_id) {
				// Redirect to home if this is a marketplace invoice
				window.location.href = "/";
				return;
			}
			// We must set the shipping address to that customer billing address on the invoice.
			if (invoice) {
				const address = { contacts: {} }
				address.street_1 = invoice.customer_billing_street_address
				address.city = invoice.customer_billing_city
				address.state = invoice.customer_billing_state
				address.zip = invoice.customer_billing_zip
				address.country = invoice.customer_billing_country
				address.contacts.name = invoice.customer_display_name
				address.contacts.email_address = invoice.customer_email
				address.contacts.phone_number = invoice.customer_phone
				this.$store.commit('UPDATE_SHIPPING_ADDRESS', address)
                return
			}
            // We have no invoice. Go home.
            window.location.href = "/";
            return
		}
	},

	methods: {}
}
</script>

<style scoped></style>
